import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import PostByIdBasicModel from "./PostByIdBasicModel";

export default class PostsModel {
    public meta: MetaModel = new MetaModel();
    public data: PostByIdBasicModel[] = [];
  }